'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

require('moment-timezone');

var _reactFontawesome = require('@fortawesome/react-fontawesome');

var _freeRegularSvgIcons = require('@fortawesome/free-regular-svg-icons');

require('./hoo.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var hooRegex = /(\d+:?\d* ?[A-Z]* ?. ?\d+:?\d* ?[A-Z]*)/g;
var hourRegex = /(\d+:?\d* ?[A-Z]*)/g;

var week = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

var openDesc = _react2.default.createElement(
  'span',
  null,
  'We are currently ',
  _react2.default.createElement(
    'span',
    { className: 'hoo-open-emphasis' },
    'open'
  ),
  ' until '
);
var closedDesc = _react2.default.createElement(
  'span',
  null,
  'We are currently ',
  _react2.default.createElement(
    'span',
    { className: 'hoo-closed-emphasis' },
    'closed'
  )
);
var permanentlyClosedDesc = _react2.default.createElement(
  'span',
  null,
  'We are ',
  _react2.default.createElement(
    'span',
    { className: 'hoo-closed-emphasis' },
    'closed'
  ),
  ' but will open sometime soon!'
);

var Hoo = function (_React$Component) {
  _inherits(Hoo, _React$Component);

  function Hoo() {
    _classCallCheck(this, Hoo);

    var _this = _possibleConstructorReturn(this, (Hoo.__proto__ || Object.getPrototypeOf(Hoo)).call(this));

    _this.state = { description: '', today: null, isOpen: null };
    _this.setDescription = _this.setDescription.bind(_this);
    _this.parseDateTime = _this.parseDateTime.bind(_this);
    return _this;
  }

  _createClass(Hoo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var timezone = this.props.timezone;

      var isValidTimezone = _moment2.default.tz.names().includes(timezone);
      if (isValidTimezone) {
        this.setDescription();
        this.checkTime = setInterval(function () {
          return _this2.setDescription();
        }, 60000);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (typeof this.checkTime !== 'undefined') {
        clearInterval(this.checkTime);
      }
    }
  }, {
    key: 'setDescription',
    value: function setDescription() {
      var timezone = this.props.timezone;

      var description = this.parseDateTime();
      var today = (0, _moment2.default)().tz(timezone).isoWeekday() - 1;
      this.setState({ description: description, today: today });
    }
  }, {
    key: 'parseDateTime',
    value: function parseDateTime() {
      var _props = this.props,
          hours = _props.hours,
          timezone = _props.timezone;

      // Compare user and business timezone

      var userTimezone = _moment2.default.tz.guess();
      var isDiffTimezone = timezone !== userTimezone;

      var now = (0, _moment2.default)().tz(timezone);
      var today = now.isoWeekday() - 1;
      var closedEntireDay = hours[today].indexOf('Closed') !== -1;
      var todayHours = !closedEntireDay && hours[today].match(hooRegex);

      if (closedEntireDay) {
        this.setState({ isOpen: false });
        return this.getNextOpeningTimeDesc(today, now, isDiffTimezone);
      }
      var closedForTheDay = _moment2.default.tz(todayHours[todayHours.length - 1].match(hourRegex)[1], 'hh:mm A', timezone).isBefore(now);
      if (closedForTheDay) {
        this.setState({ isOpen: false });
        return this.getNextOpeningTimeDesc(today, now, isDiffTimezone);
      }

      // if open or opening later in the day
      for (var x = 0; x < todayHours.length; x++) {
        var opHour = todayHours[x].match(hourRegex);
        if (now.isBefore(_moment2.default.tz(opHour[0], 'hh:mm A', timezone))) {
          this.setState({ isOpen: true });
          return _react2.default.createElement(
            'span',
            null,
            closedDesc,
            _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement('br', null),
              'We will be opening at ',
              _react2.default.createElement(
                'span',
                { className: 'hoo-emphasis emphasis-text' },
                opHour[0],
                ' ',
                isDiffTimezone && now.format('z')
              ),
              ' later today!'
            )
          );
        } else if (now.isBefore(_moment2.default.tz(opHour[1], 'hh:mm A', timezone))) {
          this.setState({ isOpen: true });
          return _react2.default.createElement(
            'span',
            null,
            openDesc,
            _react2.default.createElement(
              'span',
              null,
              '' + opHour[1],
              ' ',
              isDiffTimezone && now.format('z'),
              '!'
            )
          );
        }
      }
    }
  }, {
    key: 'getNextOpeningTimeDesc',
    value: function getNextOpeningTimeDesc(today, now, isDiffTimezone) {
      var hours = this.props.hours;

      var day = today;
      // find next day open if closed for the day or entire day
      do {
        day++;
        if (day > today + 7) {
          return permanentlyClosedDesc;
        }
      } while (hours[day % 7].indexOf('Closed') !== -1);

      var weekday = day % 7;
      var nextOpeningTime = hours[weekday].match(hooRegex)[0].match(hourRegex)[0];
      var openingDay = weekday - today === 1 ? ' tomorrow' : weekday <= today ? ' next ' + week[weekday] : ' on ' + week[weekday];

      return _react2.default.createElement(
        'span',
        null,
        closedDesc,
        '.',
        _react2.default.createElement('br', null),
        'We will be opening at\xA0',
        _react2.default.createElement(
          'span',
          { className: 'hoo-emphasis emphasis-text' },
          nextOpeningTime,
          isDiffTimezone && " " + now.format('z'),
          openingDay
        ),
        '!'
      );
    }
  }, {
    key: 'formatDisplayInfo',
    value: function formatDisplayInfo() {
      var _state = this.state,
          today = _state.today,
          isOpen = _state.isOpen;
      var hours = this.props.hours;

      var days = [];
      var hoo = [];
      var mobileHOO = [];

      hours.forEach(function (hour, idx) {
        var split = hour.split(': ');
        var className = '';
        if (today !== null && isOpen !== null) {
          className = idx === today && isOpen ? 'hoo-emphasis emphasis-text' : '';
        }
        var periods = (hour.match(/,/g) || []).length;
        var splitHOO = split[1].split(',');

        var lineBreaks = [];
        for (var i = 0; i < periods + 1; i++) {
          lineBreaks.push(_react2.default.createElement('br', { key: i }));
        }

        days.push(_react2.default.createElement(
          'div',
          { className: className, key: split[0] },
          split[0],
          ': ',
          lineBreaks
        ));
        hoo.push(_react2.default.createElement(
          'div',
          { className: className, key: hour },
          splitHOO.map(function (e) {
            return _react2.default.createElement(
              'span',
              { key: e },
              e,
              _react2.default.createElement('br', null)
            );
          })
        ));
        mobileHOO.push(_react2.default.createElement(
          'div',
          { className: className, key: split },
          split[0],
          _react2.default.createElement('br', null),
          split[1]
        ));
      });

      return { days: days, hoo: hoo, mobileHOO: mobileHOO };
    }
  }, {
    key: 'render',
    value: function render() {
      var description = this.state.description;
      var _props2 = this.props,
          showHours = _props2.showHours,
          showIcon = _props2.showIcon,
          inline = _props2.inline;

      var days = [];
      var hoo = [];
      var mobileHOO = [];
      if (showHours) {
        var formatted = this.formatDisplayInfo();
        days = formatted.days;
        hoo = formatted.hoo;
        mobileHOO = formatted.mobileHOO;
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { id: inline ? 'hoo-inline-header' : 'hoo-header' },
          showIcon && _react2.default.createElement(
            'div',
            { id: inline ? 'hoo-inline-icon' : 'hoo-icon' },
            _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, { icon: _freeRegularSvgIcons.faClock, size: '2x' })
          ),
          _react2.default.createElement(
            'div',
            null,
            description
          )
        ),
        showHours && _react2.default.createElement(
          'div',
          { id: 'hoo-desktop-hours' },
          _react2.default.createElement(
            'div',
            null,
            days
          ),
          _react2.default.createElement('div', { className: 'hoo-hour-gap' }),
          _react2.default.createElement(
            'div',
            null,
            hoo
          )
        ),
        showHours && _react2.default.createElement(
          'div',
          { id: 'hoo-mobile-hours' },
          _react2.default.createElement(
            'div',
            null,
            mobileHOO
          )
        )
      );
    }
  }]);

  return Hoo;
}(_react2.default.Component);

exports.default = Hoo;


Hoo.propTypes = {
  hours: _propTypes2.default.array.isRequired,
  showHours: _propTypes2.default.bool,
  showIcon: _propTypes2.default.bool,
  inline: _propTypes2.default.bool,
  timezone: _propTypes2.default.string.isRequired
};

Hoo.defaultProps = {
  showHours: true,
  showIcon: true,
  inline: false
};